// extracted by mini-css-extract-plugin
export default {"text":"LaZtF","icon":"lDOd6"};